<template>
  <div class="ts-flex ts-space-x-4 ts-h-full">
    <div class="ts-w-full lg:ts-w-1/2 ts-shadow-md ts-rounded-br-md ts-rounded-bl-md">
      <div class="ts-pb-10/12 ts-relative ts-rounded-tr-xl ts-rounded-tl-xl ts-overflow-hidden">
        <img
          class="ts-absolute ts-object-cover ts-h-full ts-w-full"
          :src="product.image"
          @error="setAltImg"
          alt
        />
      </div>
      <h4
        class="ts-text-gray-700 ts-font-sans ts-text-xl ts-text-left ts-mb-0 ts-p-2"
      >{{ product.product_name_en }}</h4>
    </div>
    <div class="ts-w-full ts-space-y-1">
      <div
        class="ts-flex ts-justify-between ts-w-full ts-border-b ts-border-gray-300 ts-p-2"
        v-for="u in getUom({ productId: product.product_id })"
        :key="u.uom_id"
      >
        <h4
          class="ts-mb-0 ts-font-sans"
        >- {{ u.uom_name_en }}: {{ numUom({ productId: product.product_id, uomId: u.uom_id }) }}</h4>

        <button class="btn btn-success btn-xs"
          :disabled="completeCooking(u.uom_id) == numUom({ productId: product.product_id, uomId: u.uom_id })"
          @click.prevent="onCompleted(u)"
        >
          <i class="fa fa-spinner spin" v-if="uom_completed == u.uom_id"></i>
          {{ 
            $t('kdu.complete') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
export default {
  props: ['product'],
  data(){
    return {
      uom_completed: null,
      product_error: require('@/assets/default-product.jpg')
    }
  },
  computed: {
    ...mapGetters('restaurantSale/kdu', ['getUom', 'numUom']),
    ...mapState('restaurantSale/kdu', ['resources']),
    completeCooking: vm => uomId => {
      let filter = vm.resources.filter(
        r => r.product_id == vm.product.product_id && r.uom_id == uomId && r.cooking_status_id == 3
      )
      return _.sumBy(filter, 'quantity')
    }
  },
  methods: {
    ...mapActions('restaurantSale/kdu', ['update']),
    ...mapMutations('restaurantSale/kdu', ['SET_STATUS_COMPLETE']),
    async onCompleted(uom){
      this.uom_completed = uom.uom_id
      await Promise.all(this.resources.filter(r => r.product_id == this.product.product_id && r.uom_id == uom.uom_id)
        .map(async el => {
            await this.update({
              id: el.stock_out_id,
              data: el
            }).then(() => {
              this.SET_STATUS_COMPLETE(el)
              this.$forceUpdate()
            })
        })
      )
      this.uom_completed = null
    },
    setAltImg(event) { 
        event.target.src = this.product_error
    } 
  }
}
</script>